export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <img
        src="https://public.readdy.ai/ai/img_res/2d6cd21d3f2ead3f303afa4e6fb0ab63.jpg"
        alt="Hero background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/65" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col items-center text-center">
        <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-white/60 mb-5 font-medium">
          iOS Application Development
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6 max-w-4xl">
          Modern iOS Applications<br />
          <span className="text-teal-300">for Enhanced Security</span>
        </h1>
        <p className="text-base md:text-lg text-white/75 max-w-xl leading-relaxed mb-10">
          A team of experts crafting cutting-edge VPN and Cleaner solutions to protect and optimize your mobile experience.
        </p>
        <button
          onClick={() => handleScroll('#about')}
          className="w-10 h-10 flex items-center justify-center rounded-full border border-white/40 text-white/70 hover:border-white hover:text-white transition-all duration-300 cursor-pointer animate-bounce"
          aria-label="Scroll down"
        >
          <i className="ri-arrow-down-line text-lg" />
        </button>
      </div>
    </section>
  );
}
